module.exports = __webpack_public_path__ + "static/img/knockout.59430020.png";